<template lang="pug">
.mask
  .loading_wrapper.flex_v
    img(src="@/assets/img/logo/LOGO_4.png")
    .verify.d-flex.justify-content-center.align-items-center
      progress-circle
      p 正在驗證您的信箱...
  dialog-success(
    v-if="successDialogShow",
    :title="successDialogTitle",
    :content="successDialogContent"
  )
</template>

<script>
import ProgressCircle from "@/components/common/ProgressCircle";
import { verifyEmail } from "@/api/user";
import DialogSuccess from "@/components/login/DialogSuccess";
import { errorMessage } from "@/utils/message";

export default {
  components: {
    "progress-circle": ProgressCircle,
    "dialog-success": DialogSuccess,
  },
  data() {
    return {
      successDialogShow: false,
      successDialogTitle: "",
      successDialogContent: "",
    };
  },
  created() {
    this.verifyEmail();
  },
  methods: {
    verifyEmail() {
      let inputData = {
        uid: this.$route.query.user,
        token: this.$route.query.token,
      };
      verifyEmail(inputData)
        .then(() => {
          this.successDialogShow = true;
          this.successDialogTitle = "註冊成功";
          this.successDialogContent = "Email已驗證，請重新登入會員";
          setTimeout(() => {
            this.successDialogShow = false;
            this.successDialogTitle = "";
            this.successDialogContent = "";
            this.$router.push({ name: "Home" });
          }, 1500);
        })
        .catch(() => {
          errorMessage(this, "註冊失敗", "Email驗證錯誤，請重新驗證");
          setTimeout(() => {
            this.$router.push({ name: "Home" });
          }, 1500);
        });
    },
  },
};
</script>

<style scoped lang="scss">
.mask {
  z-index: 1040;
  position: fixed;
  top: 0;
  left: 0;
  overflow: hidden;
  width: 100%;
  height: 100%;
}

.loading_wrapper {
  @include rect(100%, 100%, rgba($color_white, 0.96));
  position: absolute;
  justify-content: center;
  align-items: center;
}

.wrapper {
  position: absolute;
  top: 0;
  left: 50%;
  transform: translate(-50%, calc(50vh - 40px - 50%));
}

img {
  width: 100px;
  height: 100px;
}

.verify {
  margin-top: 20px;
}

p {
  color: $c-text;
  font-size: 20px;
  margin: 0;
  margin-left: 10px;
}

@media (max-width: 767px) {
  p {
    color: $c-text;
    font-size: 16px;
    margin: 0;
    margin-left: 10px;
  }
}
</style>
